module.exports = __webpack_public_path__ + "static/work_stereosun-32e7baaf4cb213449c4762fad63321cb.mp4";